import { Middleware } from '@reduxjs/toolkit';
import { RootState } from './';

const sessionStorageMiddleware: Middleware = (storeAPI) => (next) => (action) => {
  const result = next(action);

  const state: RootState = storeAPI.getState();
  const { error, isLoading, isTesting, progress, currentScreenId, ...other } = state.onBoardingFlow;
  const { newOnBoardingData } = state.auth;

  sessionStorage.setItem('onBoardingFlowState', JSON.stringify(other));
  if (newOnBoardingData) {
    sessionStorage.setItem('newOnBoardingDataState', JSON.stringify(newOnBoardingData));
  }

  return result;
};

export default sessionStorageMiddleware;
